import {Component, OnInit} from '@angular/core';
import {LoaderService} from '@app/core/services/loader/loader.service';
import {NotificationService} from '@app/core/services/notification/notification.service';
import {Router, ActivatedRoute} from '@angular/router';
import {WishlistService} from '../../services/wishlist/wishlist.service';
import {CartProduct} from '@app/shared/models/product';
import {CartService} from '@app/feature/end-user/services/cart/cart.service';
import { environment } from '@env/environment';
import {MessageService} from '@app/shared/services/common/message.service';
import {ErrorhandlerService} from '@app/shared/services/errorhandler/errorhandler.service';
import {PopupService} from '@app/shared/services/popup/popup.service';
import {GetWishListInterface} from '@app/feature/end-user/services/wishlist/GetWishList.interface';
import { EncrDecrService } from '../../../../shared/services/encr-decr-service.service';
import { CryptoKeyValue } from '../../../../shared/constants';
import { DesignHuddleImageService } from '@app/shared/services/design-huddle/design-huddle-image.service';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.css']
})
export class WishlistComponent implements OnInit {
  storeId !: any;
  userId !: any;
  itemCount!: number;
  wishListItem: GetWishListInterface[] = [];
  userRole: any;
  productId!: any;
  designId!: any;
  cartProduct !: CartProduct;
  imgBaseURL = '';
  parentRouteParam!: any;
  imgWareHouseBaseURL =  environment.warehouseProductCustomImageFolder;

  constructor(private loader: LoaderService,
              private notificationService: NotificationService,
              private wishlistService: WishlistService, private router: Router,
              private popupService: PopupService,
    private messageService: MessageService,
    private cartService: CartService, private activatedRoute: ActivatedRoute, private errorhandlerService: ErrorhandlerService, private EncrDecr: EncrDecrService,
    private designHuddleImageService: DesignHuddleImageService) {
    if (this.activatedRoute.parent) {
      this.activatedRoute.parent.params.subscribe(params => {
        this.parentRouteParam = params['storename'];
      });
    }
  }

  ngOnInit() {
    this.imgBaseURL = environment.imgBaseURL;
    if (localStorage.getItem('userId') !== undefined) {
      this.userId = localStorage.getItem('userId');
    } else {
      this.userId = '';
    }
    if (localStorage.getItem('storeId') !== undefined) {
      this.storeId = localStorage.getItem('storeId');
    } else {
      this.storeId = '';
    }
    this.userId = localStorage.getItem('userId');
    this.userRole = localStorage.getItem('role');
    /**Initializing Product cart item with productid, designid, styleid */
    this.cartProduct = {
      productid: this.productId,
      customizedProductId: '',
      categoryid: '',
      quantity: 1,
      sizeId: '',
      sizeName: '',
      colorCode: '',
      colorName: '',
      styleid: '',
      designid: this.designId,
      storeid: localStorage.getItem('storeId'),
      userid: localStorage.getItem('userId'),
      unitprice: 0,
      retailPrice: 0,
      warehouseProductId: 0,
      EmbroideryCost: 0,
      
    };
    this.fn_getWishlist();
  }

  fn_getWishlist() {
    this.loader.show();
    if (localStorage.getItem('userId') !== undefined && localStorage.getItem('storeId') !== undefined) {
      this.userId = localStorage.getItem('userId');
      this.storeId = localStorage.getItem('storeId');
      this.wishListItem = [];
      this.wishlistService.GetWishList(this.storeId, this.userId).subscribe((res: any) => {
        if (res.StatusCode === 200) {
          if (res.Data.ResponseData.length > 0) {            
            this.wishListItem = res.Data.ResponseData;

            for (var i = 0; i < this.wishListItem.length; i++) {
              var finalCost = 0;
              if (this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
                if (!this.wishListItem[i].IsWareHouseProduct == true) {
                  finalCost = this.wishListItem[i].UnitPrice + (this.wishListItem[i].PrintingCost * (this.wishListItem[i].CustomizedProductSides - 1));
                  //Apply discount if has any
                  if (this.wishListItem[i].Discount > 0 || this.wishListItem[i].Discount != null)
                    finalCost = finalCost - (finalCost * (this.wishListItem[i].Discount / 100));
                } else {
                  finalCost = this.wishListItem[i].UnitPrice;
                }
              }
              else if (this.userRole === 'EndUser') {
                if (!this.wishListItem[i].IsWareHouseProduct == true) {
                  finalCost = this.wishListItem[i].UnitPrice + (this.wishListItem[i].PrintingCost * (this.wishListItem[i].CustomizedProductSides - 1)) + this.wishListItem[i].RetailPrice;
                } else {
                  finalCost = this.wishListItem[i].UnitPrice;
                }
                }

              this.wishListItem[i].TotalPrice = finalCost;
            }

          } else {
            this.loader.hide();
          }
        } else if (res.StatusCode === 204) {
          if (this.itemCount <= 0) {
            this.notificationService.error(res.Message, 'Record(s)');
          }
          // this.loader.hide();
        }
        this.loader.hide();
      }, (error: any) => {
        this.loader.hide();
        this.errorhandlerService.handleError(error);
      });
    }
    this.loader.hide();
  }

  /** Function to add item to cart */
  fn_AddToCart(obj: GetWishListInterface) {
    this.userRole = localStorage.getItem('role');
    this.cartProduct = {
      productid: obj.ProductId,
      customizedProductId: obj.CustomizedProductId == 0 ? null : obj.CustomizedProductId,
      warehouseProductId: obj.WareHouseProductId == 0 ? null : obj.WareHouseProductId,
      categoryid: obj.CategoryId,
      quantity: obj.Quantity,
      sizeId: obj.SizeId,
      sizeName: obj.SizeName,
      colorCode: obj.ColorCode,
      colorName: obj.ColorName,
      styleid: obj.StyleId,
      designid: obj.DesignId,
      storeid: localStorage.getItem('storeId'),
      userid: localStorage.getItem('userId'),
      unitprice: obj.UnitPrice,
      retailPrice: obj.RetailPrice,
      EmbroideryCost: 0,
  
    };
    if (this.userRole) {
      this.loader.show();
      this.cartService.AddItemToCart(this.cartProduct).subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.cartService.GetCartItems(this.userId, this.storeId).subscribe((rescount: any) => {
            if (rescount.StatusCode === 200 && rescount.Data.ResponseData.length > 0) {
              const r = {
                cartItemCount: rescount.Data.ResponseData.length
              };
              this.messageService.sendCartCount(r);
            }
          }, (error: any) => {
            this.errorhandlerService.handleError(error);
          });
          this.notificationService.success('Product added to cart', 'Success');
          this.fn_DeleteFromWishList(obj.WishListId, false);
          this.loader.hide();
        } else {
          this.notificationService.error('An error occured', 'Error');
          this.loader.hide();
        }
      }, (error: any) => {
        this.notificationService.error('An error occured', 'Error');
        this.loader.hide();
        this.errorhandlerService.handleError(error);
      });
    } else {
      this.notificationService.info('Please login before adding item to cart', 'Cart');
      return false;
    }
  }

  fn_DeleteFromWishList(wishListId: number, flag: boolean) {
    if (localStorage.getItem('userId') !== undefined) {
      this.userId = localStorage.getItem('userId');
      this.userRole = localStorage.getItem('role');
      if (this.userRole) {
        this.loader.show();
        this.wishlistService.DeleteFromWishList(wishListId, this.userId,flag).subscribe((res: any) => {
          if (res.StatusCode === 200) {
            // this.notificationService.success('Product deleted from wishlist', 'Success');
            this.fn_getWishlist();
            this.loader.hide();
          } else {
            this.notificationService.error('An error occured', 'Error');
            this.loader.hide();
          }
        }, (error: any) => {
          this.loader.hide();
          this.errorhandlerService.handleError(error);
        });
      } else {
        this.notificationService.info('Please login before delete item from wishlist', 'Wishlist');
        this.popupService.openLogin(true);
        return false;
      }
    }
  }

  /**Redireect user to view store screen */
  fn_ViewProduct(productId: any, designId: any, type: number) {
    var encryptedproductId = this.EncrDecr.set(CryptoKeyValue.Key, String(productId));
    var encrypteddesignId = this.EncrDecr.set(CryptoKeyValue.Key, String(designId));
    this.router.navigate([this.parentRouteParam + '/product/details'], { queryParams: { pid: encryptedproductId, designId: encrypteddesignId, type: type}});
  }

  getWishlistImage(item: any): string {
    return this.designHuddleImageService.getCartItemImage(item);
  }
}
